"use client"

import { useI18n } from "./client"
import { languageTag, localeHref, type Locale } from "./routing"
import { type Translator } from "./translate"

export function translateSchema(value: unknown, t: Translator, locale: Locale, key = ""): unknown {
  if (Array.isArray(value)) return value.map(item => translateSchema(item, t, locale, key))
  if (value && typeof value === "object") return Object.fromEntries(Object.entries(value).map(([name, item]) => [name, translateSchema(item, t, locale, name)]))
  if (typeof value !== "string") return value
  if (key === "inLanguage") return languageTag(locale)
  if (["url", "item", "@id"].includes(key) && value.startsWith("https://danarolimo.com/")) {
    const url = new URL(value)
    if (url.pathname === "/" && ["#business", "#website"].includes(url.hash)) return value
    return `${url.origin}${localeHref(url.pathname, locale)}${url.search}${url.hash}`
  }
  return ["name", "description", "headline", "text", "serviceType"].includes(key) ? t(value) : value
}

export function LocalizedStructuredData({ data }: { data: Record<string, unknown> }) {
  const { t, locale } = useI18n()
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(translateSchema({ "@context": "https://schema.org", ...data }, t, locale)).replace(/</g, "\\u003c") }} />
}
